"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function t(t) {
  return t && "object" == _typeof(t) && "default" in t ? t.default : t;
}
var e = t(require("react")),
  n = t(require("html-dom-attributes-to-react-props"));
function r() {
  return (r = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }).apply(this, arguments);
}
function s(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
}
var o = function o(t) {
  return "<" + t.slice(1, -1) + ">";
};
function i(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}
var a = /\s*\/\s*>\s*$/m,
  c = function c(t) {
    throw new Error("Must implement the method " + (t || ""));
  },
  p = function () {
    function t(e) {
      (e = e || {}).scanner && (this.scanner = e.scanner, e.scanner = null), this.options = Object.assign({}, t.defaults, e);
    }
    var e = t.prototype;
    return e.parse = function (t) {
      for (var e, n, r, s = !1; t.length;) "\x3c!--" === t.substring(0, 4) ? -1 !== (e = t.indexOf("--\x3e")) ? (this.scanner.comment(t.substring(4, e)), t = t.substring(e + 3), s = !1) : s = !0 : "</" === t.substring(0, 2) ? (n = this.endTagRe.exec(t)) ? (t = RegExp.rightContext, s = !1, this.parseEndTag(RegExp.lastMatch, n[1])) : s = !0 : "<" === t.charAt(0) && ((n = this.startTagRe.exec(t)) ? (t = RegExp.rightContext, s = !1, this.parseStartTag(RegExp.lastMatch, n[1], n)) : s = !0), s && (0 === (e = t.indexOf("<")) && (e = t.substring(1).indexOf("<")), -1 === e ? (r = t, t = "") : (r = t.substring(0, e), t = t.substring(e)), this.options.ignoreWhitespaceText && /^\s*$/.test(r) || this.scanner.characters(r)), s = !0, n = null;
    }, e.parseStartTag = function (t, e, n) {
      var r = a.test(t),
        s = n[2];
      r && (s = s.replace(/\s*\/\s*$/, ""));
      var o = this.parseAttributes(e, s);
      this.scanner.startElement(e, o, r, n[0]);
    }, e.parseEndTag = function (t, e) {
      this.scanner.endElement(e);
    }, e.parseAttributes = function (t, e) {
      var n = {};
      return e.replace(this.attrRe, function (t, e, r, s, o, i, a, c) {
        n[e] = c || i || s || !0;
      }), n;
    }, t;
  }();
p.defaults = {
  ignoreWhitespaceText: !1
}, p.prototype.attrRe = /([^=\s]+)(\s*=\s*(("([^"]*)")|('([^']*)')|[^>\s]+))?/gm, p.prototype.endTagRe = /^<\/([^>\s]+)[^>]*>/m, p.prototype.startTagRe = /^<([^>\s\/]+)((\s+[^=>\s]+(\s*=\s*(("[^"]*")|('[^']*')|[^>\s]+))?)*)\s*\/?\s*>/m, p.prototype.scanner = {
  startElement: function startElement() {
    c("startElement");
  },
  endElement: function endElement() {
    c("endElement");
  },
  characters: function characters() {
    c("characters");
  },
  comment: function comment() {
    c("comment");
  }
};
var h = p,
  u = i(function (t, e) {
    var n = 1,
      r = 10,
      o = function () {
        function t(t) {
          var e = t.nodeType,
            r = t.attrs,
            s = t.textContent,
            o = t.parentNode,
            i = t.childNodes;
          this.tagName = t.tagName, this.nodeType = e, this.textContent = s, this.parentNode = o, this.attrs = r, this.childNodes = i || [], e === n && (r.id && (this.id = r.id), r.class && (this.className = r.class));
        }
        var e = t.prototype;
        return e.appendChild = function (t) {
          t && (t.parentNode = this, this.childNodes.push(t));
        }, e.insertAfter = function (t, e) {
          var n = this;
          if (!e) return this.appendChild(t);
          this.childNodes.some(function (r, s) {
            if (r === e) return t.parentNode = n, n.childNodes.splice(s, 0, t), !0;
          });
        }, e.insertBefore = function (t, e) {
          var n = this;
          if (!e) return this.appendChild(t);
          this.childNodes.some(function (r, s) {
            if (r === e) return t.parentNode = n, 0 === s ? n.childNodes.unshift(t) : n.childNodes.splice(s - 1, 0, t), !0;
          });
        }, e.toJSON = function () {
          var t = {
            tagName: this.tagName,
            nodeType: this.nodeType
          };
          return this.childNodes.length && (t.childNodes = this.childNodes), this.textContent && (t.textContent = this.textContent), this.attrs && (t.attrs = this.attrs), this.id && (t.id = this.id), this.className && (t.className = this.className), t;
        }, e.getElementsByTagName = function (t) {}, e.getElementsByClassName = function (t) {}, t;
      }();
    (e = t.exports = o).NODE_TYPE = {
      ELEMENT_NODE: n,
      TEXT_NODE: 3,
      COMMENT_NODE: 8,
      DOCUMENT_NODE: 9,
      DOCUMENT_TYPE_NODE: r
    };
    var i = function (t) {
        function e(e) {
          var n;
          return (n = t.call(this, e) || this).id = void 0, n.nodeType = r, n.systemId = e.systemId || "", n.publicId = e.publicId || "", n.name = e.name || "html", n;
        }
        return s(e, t), e.prototype.toJSON = function () {
          return {
            tagName: this.tagName,
            nodeType: this.nodeType,
            publicId: this.publicId,
            systemId: this.systemId,
            name: this.name
          };
        }, e;
      }(o),
      a = function (t) {
        function e() {
          return t.apply(this, arguments) || this;
        }
        return s(e, t), e.prototype.getElementById = function (t) {
          return t ? function e(r) {
            var s;
            return r.some(function (r) {
              return r.nodeType === n && (s = r.id === t ? r : e(r.childNodes));
            }), s;
          }(this.childNodes) : null;
        }, e;
      }(o);
    e.DoctypeNode = i, e.DocumentNode = a;
  }),
  d = u.NODE_TYPE,
  l = d.ELEMENT_NODE,
  f = d.TEXT_NODE,
  m = d.COMMENT_NODE,
  N = d.DOCUMENT_NODE,
  g = d.DOCUMENT_TYPE_NODE,
  E = u.DoctypeNode,
  y = u.DocumentNode,
  T = /^\s*<!doctype\s+(html)(\s+public(\s+('[^']+'|"[^"]+"))?(\s+('[^']+'|"[^"]+"))?)?\s*/i,
  v = {
    doctype: function doctype(t, e, n, r, s) {
      var o = t.path[t.path.length - 1],
        i = T.exec(s) || [],
        a = new E({
          tagName: "doctype",
          nodeType: g,
          parentNode: o,
          name: i[1],
          publicId: i[4] && i[4].substring(1, i[4].length - 1),
          systemId: i[6] && i[6].substring(1, i[6].length - 1)
        });
      o.appendChild(a);
    },
    _default: function _default(t, e, n, r, s) {
      var o = t.path[t.path.length - 1],
        i = new u({
          tagName: e,
          nodeType: l,
          attrs: n,
          parentNode: o
        });
      o.appendChild(i), r || t.path.push(i);
    },
    _selfCloseTag: function _selfCloseTag(t, e, n, r, s) {
      v._default(t, e, n, !0, s);
    }
  };
v["!doctype"] = v.doctype, ["area", "base", "link", "br", "hr", "col", "command", "embed", "img", "input", "keygen", "meta", "param", "source", "track", "wbr"].forEach(function (t) {
  v[t] = v._selfCloseTag;
});
var x = function () {
    function t() {
      this.reset();
    }
    var e = t.prototype;
    return e.reset = function () {
      this.rootNode = new y({
        tagName: "document",
        nodeType: N
      }), this.path = [this.rootNode];
    }, e.getRootNode = function () {
      return this.rootNode;
    }, e.startElement = function (t, e, n, r) {
      return t = t.toLowerCase(), v[t] ? v[t](this, t, e, n, r) : v._default(this, t, e, n, r);
    }, e.endElement = function (t) {
      this.path.pop();
    }, e.characters = function (t) {
      if (!/^\s*$/.test(t)) {
        var e = this.path[this.path.length - 1],
          n = new u({
            tagName: "text",
            nodeType: f,
            textContent: t,
            parentNode: e
          });
        e.appendChild(n);
      }
    }, e.comment = function (t) {
      var e = this.path[this.path.length - 1],
        n = new u({
          tagName: "comment",
          nodeType: m,
          textContent: t,
          parentNode: e
        });
      e.appendChild(n);
    }, t;
  }(),
  C = i(function (t, e) {
    (e = t.exports = function (t) {
      function e(e) {
        return (e = e || {}).scanner || (e.scanner = new x()), t.call(this, e) || this;
      }
      return s(e, t), e.prototype.parse = function (e) {
        t.prototype.parse.call(this, e);
        var n = this.scanner.getRootNode();
        return this.scanner.reset(), n;
      }, e;
    }(h)).RawHtmlParser = h, e.HtmlScanner = x;
  }),
  O = function (t) {
    function e() {
      var e;
      return (e = t.apply(this, arguments) || this).isScript = !1, e;
    }
    s(e, t);
    var n = e.prototype;
    return n.startElement = function (e, n, r, s) {
      if (this.isScript) {
        var o = this.path && this.path[this.path.length - 1],
          i = new u({
            tagName: "text",
            nodeType: u.NODE_TYPE.TEXT_NODE,
            textContent: s,
            parentNode: o,
            attrs: n,
            childNodes: null
          });
        o && o.appendChild(i);
      } else "script" === (e = e.toLowerCase()) && (this.isScript = !0), t.prototype.startElement.call(this, e, n, r, s);
    }, n.endElement = function (e) {
      if ("script" === e && (this.isScript = !1), this.isScript) {
        var n = this.path && this.path[this.path.length - 1],
          r = new u({
            tagName: "text",
            nodeType: u.NODE_TYPE.TEXT_NODE,
            textContent: "</" + e + ">",
            parentNode: n,
            attrs: null,
            childNodes: null
          });
        n && n.appendChild(r);
      } else t.prototype.endElement.call(this, e);
    }, n.characters = function (e) {
      if (this.isScript) {
        var n = this.path && this.path[this.path.length - 1],
          r = new u({
            tagName: "text",
            nodeType: u.NODE_TYPE.TEXT_NODE,
            textContent: e,
            parentNode: n,
            attrs: null,
            childNodes: null
          });
        n && n.appendChild(r);
      } else t.prototype.characters.call(this, e);
    }, n.comment = function (e) {
      this.isScript || t.prototype.comment.call(this, e);
    }, e;
  }(x),
  _ = function _(t) {
    return t.childNodes.reduce(function (t, e) {
      return 3 === e.nodeType ? t + e.textContent : t;
    }, "");
  },
  b = function (t) {
    function e() {
      var e;
      return (e = t.apply(this, arguments) || this).state = {
        error: !1
      }, e;
    }
    s(e, t);
    var n = e.prototype;
    return n.componentDidCatch = function (t, e) {
      this.props.onError(t, e), this.setState({
        error: !0
      });
    }, n.render = function () {
      return this.state.error ? null : this.props.children;
    }, e;
  }(e.Component);
exports.Shortcodes = function (t) {
  var s = t.components,
    i = void 0 === s ? {} : s,
    a = t.content,
    c = t.failGracefully,
    p = void 0 === c || c,
    h = t.onError,
    u = void 0 === h ? function () {} : h,
    d = e.useMemo(function () {
      return Object.keys(i).reduce(function (t, n) {
        var s;
        return r({}, t, ((s = {})[n.toLowerCase()] = p ? function (t, n) {
          return function (r) {
            return e.createElement(b, {
              onError: n
            }, e.createElement(t, r));
          };
        }(i[n], u) : i[n], s));
      }, {});
    }, [i]),
    l = e.useMemo(function () {
      return Object.keys(d);
    }, [d]),
    f = e.useMemo(function () {
      return t = l, e = new RegExp("(\\[)(\\s*(" + t.join("|") + ")(\\s+([a-z0-9\\-_]+|([a-z0-9\\-_]+)\\s*=\\s*([a-z0-9\\-_]+|\\d+\\.\\d+|'[^']*'|\"[^\"]*\")))*\\s*\\/?\\s*)(\\])", "ig"), n = new RegExp("(\\[)(\\s*\\/(" + t.join("|") + ")\\s*\\/?\\s*)(\\])", "ig"), function (t) {
        return t.replace(e, o).replace(n, o);
      };
      var t, e, n;
    }, [l]),
    m = e.useMemo(function () {
      var t = f(a);
      try {
        return function (t) {
          return new C({
            scanner: new O()
          }).parse(t);
        }(t).childNodes.map(function (t) {
          return function t(s, o) {
            if (1 === s.nodeType) {
              var i = o[s.tagName.toLowerCase()],
                a = i || s.tagName,
                c = n(s.attrs);
              if (!i) {
                if ("script" === String(a) || "style" === String(a)) return e.createElement(a, r({}, c, {
                  dangerouslySetInnerHTML: {
                    __html: _(s)
                  }
                }));
                if ("textarea" === String(a) && s.childNodes.length > 0) return e.createElement(a, r({}, c, {
                  defaultValue: _(s)
                }));
              }
              return e.createElement.apply(e, [a, c].concat(s.childNodes.map(function (e) {
                return t(e, o);
              })));
            }
            return 3 === s.nodeType ? s.textContent : null;
          }(t, d);
        });
      } catch (e) {
        return console.error("Failed to parse shortcodes:", t), [];
      }
    }, [a, d, f]);
  return e.createElement.apply(e, [e.Fragment, null].concat(m));
};
//# sourceMappingURL=flight-shortcodes.cjs.production.min.js.map